// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const circle = "Progress__circle__AHiGI";
export const confirmed = "Progress__confirmed__rMm1X";
export const earned = "Progress__earned__24TFH";
export const expired = "Progress__expired__d2Vr1";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const pending = "Progress__pending__44kMI";
export const progress = "Progress__progress__kUg9-";
export const progressInner = "Progress__progressInner__su+ir";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";